import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TerminalIcon from '@mui/icons-material/Terminal';
import { ICodeTask } from '../../../lib/interfaces/CodeTask';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import { FIELD_TYPES } from '../../Form/form.utils';
import ContentRenderer from '../Content/ContentRenderer';
import {
	CONTENT_FIELDS,
	getContentFieldValue,
} from '../../../lib/helpers/content.helper';
import ContentTitleWithIcon from '../../Simple/ContentTitle/ContentTitleWithIcon';
import FileRenderer from '../FileRenderer/FileRenderer';
import HintGeneric from '../Hint/HintGeneric';
import CodeEditorLayoutWithFiles from './CodeEditorLayoutWithFiles';

type CodeTaskReferenceProps = {
	field: IEntityContentField;
	taskSlug: string;
	taskId: number;
};

const CodeTaskReference: FC<CodeTaskReferenceProps> = ({
	field,
	taskSlug,
	taskId,
}) => {
	const reference = field.reference as ICodeTask;
	const { t, i18n } = useTranslation();
	const currentLanguage: string = i18n.language;

	const title =
		reference?.content &&
		getContentFieldValue({
			entityContent: reference.content,
			field: CONTENT_FIELDS.NAME,
			language: currentLanguage,
		});

	return (
		<div>
			<ContentTitleWithIcon
				content={title || t('codeTask')}
				icon={TerminalIcon}
				id={field.id}
				className="content-column"
			/>
			{reference?.content[currentLanguage]?.map((block: IEntityContentField) => {
				if (block.type === FIELD_TYPES.RICH_EDITOR) {
					return (
						<ContentRenderer
							html={block.content}
							key={block.name}
							className="content-column"
						/>
					);
				}
				if (block.type === FIELD_TYPES.FILE) {
					return <FileRenderer key={block.name} field={block} />;
				}
				if (
					block.type === FIELD_TYPES.CODE_EDITOR &&
					block.name === `solution_${currentLanguage}`
				) {
					return (
						<HintGeneric title={t('solution')} key={block.name}>
							<CodeEditorLayoutWithFiles
								field={block}
								wrapperField={reference}
								parentField={block}
								taskSlug={taskSlug}
								pageView={false}
								backButton={false}
								taskId={taskId}
							/>
						</HintGeneric>
					);
				}
				if (block.type === FIELD_TYPES.CODE_EDITOR) {
					return (
						<CodeEditorLayoutWithFiles
							key={block.name}
							field={block}
							wrapperField={reference}
							parentField={block}
							taskSlug={taskSlug}
							pageView={false}
							backButton={false}
							taskId={taskId}
						/>
					);
				}
			})}
			{!!reference?.code && (
				<CodeEditorLayoutWithFiles
					key={field.name}
					field={reference?.code}
					wrapperField={reference}
					parentField={field}
					taskSlug={taskSlug}
					pageView={false}
					backButton={false}
					taskId={taskId}
				/>
			)}
		</div>
	);
};

export default CodeTaskReference;
